export async function getList({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.categories.getList();
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  commit('setList', []);
  return [];
}

export async function getTree({commit}) {
  const {errResponse, data: response} = await this.$frontendRepositories.categories.getTree();
  if (!errResponse && response.success) {
    commit('setTree', response.data);
    return response;
  }

  commit('setTree', []);
  return [];
}

export async function updateCategoryTree({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.categories.updateTree(payload);
  await dispatch('getTree');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function createCategory({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.categories.create(payload);
  await dispatch('getTree');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateCategory({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.categories.update(payload.id, payload);
  await dispatch('getTree');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findCategoryById({commit}, payload) {
  return await this.$frontendRepositories.categories.show(payload);
}

export async function deleteCategory({dispatch}, payload) {
  const response = await this.$frontendRepositories.categories.delete(payload);
  await dispatch('getTree');
  return response;
}
